import { render } from "./CustomerTripInfo.vue?vue&type=template&id=4ac36575&scoped=true"
import script from "./CustomerTripInfo.vue?vue&type=script&lang=js"
export * from "./CustomerTripInfo.vue?vue&type=script&lang=js"

import "./CustomerTripInfo.vue?vue&type=style&index=0&id=4ac36575&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac36575"]])

export default __exports__